define([ // START Open Requre.JS wrapper
  'require',
  'jquery',
  'md5',
  "wcs.product-list-view",
  'wcs.utils'
], function (require, $, md5, productView, Utils) {

    "use strict";

    var DEBUG = false, // make true to enable debug output
        PLUGIN_IDENTIFIER = "RolloverAltView",
        productCarouselOn = $('.product-slideshow').length > 0;

    var RolloverAltView = function (element, options) {
        this.element = element;
        this.options = options || {};
        // This next line takes advantage of HTML5 data attributes
        // to support customization of the plugin on a per-element
        // basis.
        this.metadata = $(this.element).data('options');
    };

    RolloverAltView.prototype = {
        init: function () {
            if (DEBUG && console) console.log('$.fn.RolloverAltView init');
            this.config = $.extend({}, this.defaults, this.options, this.metadata);
            this.imageSetName = '';
            // Used to keep state, not to enable/disable
            this.toggle = false;
            this.image = $('picture.product-block-views-container', this.element);
            this.isGridLayoutImagePresetsEnabled =  WCS_CONFIG.get('grid::gridLayoutImagePresetsEnabled');
            this.enableLazyLoadCarrouselForMobile = WCS_CONFIG.get('grid::gridLazyLoadCarouselMobileEnabled') || false;
            this.lazyLoadViewPortOffset = WCS_CONFIG.get('grid::gridLazyLoadCarouselViewPortOffset') || 0;
            this.isCarouselDotsEnabled = WCS_CONFIG.get('grid::gridCarouselDotsEnabled') || false;
            this.enableFullLazyLoad = WCS_CONFIG.get('grid::enableFullLazyLoad') || false;
            this.enableVideoLoad = WCS_CONFIG.get('grid::enableVideoLoad') || false;
            this.altImageLoadWhenVisible = WCS_CONFIG.get('grid::altImageLoadWhenVisible') || false;
            this.lazyLoadInitClass = 'lazy-load-initialized';
            this.$element = $(this.element);
            this.$productBlockViewFigure = this.$element.find('.product-block-view .product-block-figure');
            this.removeDataOnCycleInitialize = false;
            this.bindEventHandlers();

            if (this.enableLazyLoadCarrouselForMobile) {
              this.lazyLoadEventsHandlers();
            }
            if (this.enableFullLazyLoad) {
                this.restrictToOnlyVideo = true;
                this.lazyLoadEventsHandlers();
                this.restrictToOnlyVideo = false;

                if(!this.$element.hasClass(this.lazyLoadInitClass) && this.isProductBlockInViewPort()) {
                    this.triggerCarousel();
                }

            }
            return this;
        },

        initializeCycle: function() {
          var self = this,
              $carousel = self.$element.find('.product-block-pdp-url.product-slideshow'),
              $productBlockView = self.$element.children('.product-block-view');

          if (this.$element.hasClass(self.lazyLoadInitClass) || $carousel.hasClass('active')) {
            return;
          }

          require([
            'cycle',
            'pubsub'
          ],
          function(cycle) {
            var settings = {
              fx: "scrollHorz",
              progressive: self.slides,
              next: $productBlockView.find('.arrow-next'),
              prev: $productBlockView.find('.arrow-prev'),
              swipe: true,
              maxZ: 10,
              slides: "> .product-block-views-container",
              timeout: 0
            };

            if (self.isCarouselDotsEnabled) {
              //extend settings for carousel
              settings = $.extend( {}, settings, {
                pager: $productBlockView.find('.pager-container'),
                pagerTemplate: '',
                pagerActiveClass: 'active',
              });
            }

            // Remove any existing data to avoid errors on initializing new one after selecting color swatch
            if (self.removeDataOnCycleInitialize) {
              $.each($carousel.data(), function (attr) {
                $carousel.removeAttr("data-" + attr);
              });
              $carousel.removeData();
            }

            // Build carousel
            $carousel.addClass('carousel-initializing');
            $carousel.cycle(settings);
            $carousel.addClass('active');
            $productBlockView.addClass('active');

            $carousel.one('cycle-update-view', function (ev, opts) {
                $carousel.removeClass('carousel-initializing');
            });

            if (self.enableLazyLoadCarrouselForMobile) {
              self.$element.addClass(self.lazyLoadInitClass);
            }

            // On mobile once carousel is created move to next slide
            // automatically (since user already clicked the arrow to trigger it)
            if (self.config.device === 'mobile' && !self.enableLazyLoadCarrouselForMobile) {
              self.currentCarousel.cycle('next');
            }
          });
        },

        getVideoUrl: function(images) {
            var videoUrl;
            if( !this.enableVideoLoad ){
                return false;
            }
            images.forEach(function (image, index) {
                if (image.indexOf('video') !== -1) {
                    console.log(index, image);
                    videoUrl = image.split(';')[0];
                }
            });
            return videoUrl;
        },

        buildVideoPreview: function(videoUrl, $element) {
            var videoMarkup;
            if (videoUrl) {
                var url = SCENE7.SERVER_URL_CONTENT + videoUrl;
                videoMarkup = '<video class="mol-video-player" preload="auto" loop="" autoplay="" muted="" playsinline=""><source src=' + url + ' type="video/mp4"></video>';
                $element.find('.pdp-url-js').html(videoMarkup);
            }
        },

        buildCarouselSlides: function(images) {
          var self = this;

          images.forEach(function(image) {
            var img = image.split(';')[0];
            var slideImage = self.image.clone();

            slideImage.addClass('slide');

            // Set the image URLs with presets
            var query = '?',
              altImageUnit = slideImage.find('img, source'),
              urlFragments = altImageUnit.attr('srcset').split('?');
            if (urlFragments.length == 2)
              query += urlFragments[1];

            var altImagePath = SCENE7.SERVER_URL + img + query;

            if(self.isGridLayoutImagePresetsEnabled) {
              var s7Profile = productView.getS7PresetWithScreenSize();
              altImageUnit.attr('data-s7-profile', s7Profile);
              altImagePath = productView.getNewImgUrlWithPreset(altImagePath, s7Profile);
            }

            altImageUnit.attr({
              'srcset': altImagePath,
              'src': altImagePath
            });

            // Populates slides array for Cycle's progressive loading feature
            self.slides.push(slideImage.wrap('<div/>').parent().html());
          });

          // Populate dots base on number of images (New Images + Original)
          self.buildCarouselDots(self.slides.length + 1);
        },

        createCarousel: function(images) {
          var self = this,
              $productBlockView = this.image.closest('.product-block-view');

          self.slides = [];

          if (DEBUG) console.log('Create Carousel: TOTAL IMAGES', images.length);

          if (images.length >= 2) {

            // Enable arrows
            $productBlockView.find('.arrows-container').addClass('active');

            // Remove first image since we already have it, filter out empty values
            // and limit total images to 3
            var slicedImages = images
              .filter(function(image) {
                return image.split(';')[0];
              })
              .slice(1, 3);

            if (DEBUG) console.log('Create Carousel: SLICED IMAGES', slicedImages);

            self.buildCarouselSlides(slicedImages);
            self.initializeCycle();
          }
        },

        carouselEvents: function () {
          if (DEBUG) console.log('$.fn.RolloverAltView carouselEvents');
          var self = this;

          // When swatch is selected, destroy carousel and
          // delete previously duplicated elements
          $.pubsub('subscribe', 'PLP.SWATCH.CLICKED', function (msg, event) {
            if (DEBUG) console.log('Create Carousel: SWATCH CLICKED', event);

            // Perform operations only if swatch changed for the instance.
            if (event.productBlock.data('partNumber') === self.$element.data('partNumber')) {
              event.productBlock.find('.product-slideshow').removeClass('active').cycle('destroy');
              event.productBlock.find('.view-js').removeClass('active');
              event.productBlock.find('.slide').remove();
              self.imageSetName = '';
              if (self.enableLazyLoadCarrouselForMobile) {
                event.productBlock.removeClass(self.lazyLoadInitClass);
                self.removeDataOnCycleInitialize = true;
                self.imageSetName = event.newSelected.imgSet[0];
                self.fetchAltView();
              }
            }
          });

          $.pubsub('subscribe','window.resize',function(event,data) {
            self.adjustContainerHeight();
          });

          $.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
            if (DEBUG) console.log('Create Carousel: BREAKPOINT - Destroy and remove');
            $('.product-slideshow.active').cycle('destroy');
            $('.slide').remove();
            self.imageSetName = '';
          });

          // Prevent flashing carousel images while fetching
          $.pubsub('subscribe', 'vfdp.wcs.product_list.VIEW_LAYOUT_UPDATED', function (msg, event) {
            if (DEBUG) console.log('Create Carousel: LAYOUT UPDATED', self.image.find('img'));
            self.adjustContainerHeight();
          });
        },

        cloneImage: function ($el) {
            if (DEBUG && console) console.log('$.fn.RolloverAltView cloneImage');
            // Clone the product image for the rollover image.
            // We'll update the image reference later
            this.altImage = this.image.clone();
            this.altImage.removeClass('views-container-js').addClass('alt-views-container-js alt-views-container');
            this.altImage.removeAttr('style');
            this.altImage.insertBefore(this.image);

            // Trigger picture fill update
            main.update();
        },

        getImageSetName: function () {
            if (DEBUG && console) console.log('$.fn.RolloverAltView getImageSetName');
            return $(this.element).data('s7-image-set-name');
        },

        adjustContainerHeight: function () {
          if (DEBUG) console.log('$.fn.RolloverAltView: adjustContainerHeight');
          var $productBlockFigure = this.image.closest('.view-js'),
              $container = this.image.closest('.catalog-results-js'),
              // Grab first image height and apply to all containers avoiding the lazy loaded images to have 0 as height.
              imageContainerHeight = $container.find('.views-container-js img').eq(0).height();

          // Sets container height to prevent flashing carousel images while fetching
          $productBlockFigure.css('min-height', imageContainerHeight);
        },

        triggerCarousel: function () {
          if (DEBUG) console.log('$.fn.RolloverAltView triggerCarousel', this.imageSetName, this.getImageSetName());
          if (this.imageSetName != this.getImageSetName()) {
              this.imageSetName = this.getImageSetName();
              this.fetchAltView();
          }
        },

        enhanceSlideImgOnClick: function() {
          var self = this;
          var $img = $(self.image).find('.product-block-views-selected-view-main-image');
          var currentS7Profile = $img.data('s7Profile');
          var s7Profile = productView.getS7PresetWithScreenSize();
          if (currentS7Profile != s7Profile) {
            $img = productView.updateImgWithS7Preset($img, s7Profile);
          }
        },

        bindCarouselEventHandlers: function() {
          if (DEBUG && console) console.log('$.fn.RolloverAltView bindCarouselEventHandlers');
          var self = this,
              $imageContainer = $(this.image.parent());

          var $arrows =  $('.arrows-container', this.element);
          if (DEBUG) console.log('$.fn.RolloverAltView: Carousel ON');

          $arrows.off();
          self.carouselEvents();
          self.adjustContainerHeight();

          if (self.config.device === 'mobile') {
            if (self.enableLazyLoadCarrouselForMobile) {
              self.handleLazyLoadCarousel();
            } else {
              // On mobile view carousel is triggered by arrow click
              $arrows.on('touchstart', function(event) {
                self.currentCarousel = $(event.target).closest('.product-block-view').find('.product-slideshow');
                self.triggerCarousel();
              });
            }

          } else {
            // On desktop carousel is triggered by mouse over
            $imageContainer.hover(function () {
              self.triggerCarousel();
            });
          }

          if(self.isGridLayoutImagePresetsEnabled) {
            $arrows.on('click', function() {
              self.enhanceSlideImgOnClick();
            });
          }
        },

        bindEventHandlers: function () {
            if (DEBUG && console) console.log('$.fn.RolloverAltView bindEventHandlers');
            var self = this,
                entered = false,
                $imageContainer = $(this.image.parent());

            // Only create carousel when feature is ON
            if (productCarouselOn) {
              self.bindCarouselEventHandlers();
            } else {

                if (self.imageSetName != self.getImageSetName()) {
                    self.imageSetName = self.getImageSetName();
                }

                $.pubsub('subscribe', 'PLP.SWATCH.CLICKED', function (msg, event) {
                    if (DEBUG) console.log('Create Carousel: SWATCH CLICKED', event);
                    // Perform operations only if swatch changed for the instance.
                    if (self.imageSetName != self.getImageSetName()) {
                        self.imageSetName = self.getImageSetName();
                    }

                    if (event.productBlock.data('partNumber') === self.$element.data('partNumber')) {
                        self.image.removeAttr('style');
                        if ( event.newSelected && event.newSelected.images && event.newSelected.images.length > 1) {
                            self.showAltImage = true;
                            var img = event.newSelected.images[1].split(';')[0];
                            if (!self.altImage && $imageContainer) {
                                self.cloneImage($imageContainer);
                            }
                            self.changeAltImageSource(img);
                        } else { // In case of only one image - remove the alt image
                            event.productBlock.find('.alt-views-container-js').remove();
                            self.isInitialized = false;
                            self.toggle = false;
                            delete self.altImage;
                            self.showAltImage = false;
                        }
                    }
                });
              var productGridCommonInlineQuickviewDesktopEnabled = WCS_CONFIG.get('grid::productGridCommonInlineQuickviewDesktopEnabled') || false;
              if(!productGridCommonInlineQuickviewDesktopEnabled) {
                $imageContainer.hover(function (event) {
                    if (!self.isInitialized) {
                        self.fetchAltView($imageContainer, true, null);
                    } else {
                        if (event.relatedTarget && $(event.relatedTarget).is('button') || $(event.relatedTarget).hasClass('quickshop-js') ) {
                            return;
                        }
                        self.toggleImage();
                    }
                    entered = true;
                }, function (event) {
                    if (entered) {
                        //create alt image on mouse exit if doesn't exist (when page loads with mouse over an image)
                        if (!self.altImage && !self.isInitialized) {
                            self.cloneImage($imageContainer);
                        }
                        if (event.relatedTarget && $(event.relatedTarget).is('button') || $(event.relatedTarget).hasClass('quickshop-js')) {
                            return;
                        }
                        self.toggleImage();
                        if (self.showAltImage === undefined || self.isInitialized && self.showAltImage === false ) {
                            self.image.removeAttr('style');
                        }
                        entered = false;
                    }
                });
              }

            }
        },

        handleLazyLoadCarousel: function() {
          var self = this;

          // Reacquire element when element is lost due to rerendering
          if (self.$element.length > 0 && !self.$element[0].isConnected) {
            var partNumber = self.$element.data().partNumber,
              partNumberString = '[data-part-number="' + partNumber + '"]',
              $newElement = $('.product-block-js' + partNumberString);
              self.$element = $newElement;
          }

          // Only init if it has not been init and is in the viewport
          if(!self.$element.hasClass(self.lazyLoadInitClass) && self.isProductBlockInViewPort()) {
            self.triggerCarousel();
          }
        },

        isProductBlockInViewPort: function() {
          var self = this;
          if( self.$element.length === 0 ){
              return false;
          }

          if (self.altImageLoadWhenVisible) {
             return self.isProductBlockVisible(self.$element);
          }
          else {
              if (!self.$productBlockViewFigure.length) {
                  return false;
              }
              var rect = self.$productBlockViewFigure[0].getBoundingClientRect(); // use the product block view's figure instead of the whole product block
              return (
                  rect.top >= 0 &&
                  rect.left >= 0 &&
                  rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight) + self.lazyLoadViewPortOffset) &&
                  rect.right <= (window.innerWidth || document.documentElement.clientWidth)
              );
          }
        },

        isProductBlockVisible: function ($element) {

            var viewHeight = $(window).height(),
                scrollTop = $(window).scrollTop(),
                y = $element.offset().top,
                elementHeight = $element.height();

            return ((y < (viewHeight + scrollTop)) && (y > (scrollTop - elementHeight)));
        },

        lazyLoadEventsHandlers: function() {
          var self = this;

          self.windowScrollEventToken = $.pubsub('subscribe', 'vfdp.wcs.product_list.WINDOW_SCROLL_ENDED', function (msg, event) {
            self.handleLazyLoadCarousel();
          });
        },

        finishLazyLoadCarousel: function() {
          var self = this;

          self.$element.addClass(self.lazyLoadInitClass);
          if (self.windowScrollEventToken) {
            $.pubsub('unsubscribe', self.windowScrollEventToken);
          }
        },

        buildCarouselDots: function(numberOfSlide) {
          var self = this;
          var $productBlockView = $(self.$element.children('.product-block-view'));
          if (!self.isCarouselDotsEnabled || $productBlockView.hasClass('pager-activated')) {
            return;
          }
          $productBlockView.append("<div class='pager-container></div>").addClass('pager-activated');

          var el= '<span class="pager"></span>';
          for(var i=1; i<numberOfSlide; i++) {
              el += '<span class="pager"></span>';
          }

          $productBlockView.append(el);
          $(".pager", $productBlockView).wrapAll("<div class='pager-container'></div>");

        },

        toggleImage: function () {
            if (DEBUG && console) console.log('$.fn.RolloverAltView toggleImage');
            if (DEBUG && console) console.log('this.showAltImage:' + this.showAltImage);
            if (this.showAltImage === false) {
                return;
            }
            if (this.isNewColorFetching) {
                return;
            }
            var self = this,
                fade = this.toggle ? 1 : 0;
            // Swap the toggle state
            this.toggle = !this.toggle;
            // Clear the timeout from the previous toggle
            clearTimeout(this.timeout);
            // Set the new timeout for this event
            this.timeout = setTimeout(function () {
                // Fade the image as needed
                if (self.showAltImage === undefined || self.isInitialized && self.showAltImage === false ) {
                    self.image.removeAttr('style');
                    return;
                }
                self.image.fadeTo(self.config.fadeSpeed, fade);
            }, this.config.hoverDelay);
        },

        fetchAltView: function ($imageContainer, toggleImage, colorChange) {
            if (DEBUG && console) console.log('$.fn.RolloverAltView fetchAltView');
            var self = this,
                // Need a unique name so multiple JSONP callbacks don't collide
                // But also make it specific to the product so the response can be cached
                callback = 'cb_' + md5(self.imageSetName);
            if (colorChange) {
                self.isNewColorFetching = true;
            }

            $.ajax({
                url: SCENE7.SERVER_URL + self.imageSetName + '?req=imageset,json',
                dataType: 'jsonp',
                jsonpCallback: callback,
                data: {
                    handler: callback
                },
                cache: true
            }).done(function (data) {
                if (DEBUG && console) console.log('$.fn.RolloverAltView AJAX done : ', data);

                var img,
                    images = data.IMAGE_SET.split(',');

                var videoUrl = self.getVideoUrl(images);
                if( !videoUrl &&  self.restrictToOnlyVideo){
                    return;
                }
                if( videoUrl ){
                    self.buildVideoPreview(videoUrl, self.$element);
                }
                else {
                    if (productCarouselOn) {
                        self.createCarousel(images);
                    } else {
                        if (images.length >= 2)
                            img = images[1].split(';')[0];

                        self.showAltImage = false;
                        if( images.length > 1){
                            self.showAltImage = true;
                        }
                        else{
                            // remove alt image and reset main image (in case there is toggle running in parallel
                            if (self.altImage) {
                                self.altImage.remove();
                                delete self.altImage;
                            }
                            self.image.removeAttr('style');
                        }

                        if (self.showAltImage && !self.altImage && $imageContainer) {
                            self.cloneImage($imageContainer);
                        }

                        self.changeAltImageSource(img);

                        if (toggleImage) {
                            self.toggleImage();
                        }
                    }
                }
                self.isNewColorFetching = false;
                self.isInitialized = true;
            }).fail(function (jqXHR, status, error) {
                if (DEBUG && console) console.log('$.fn.RolloverAltView AJAX error : ', jqXHR, status, error);
                self.isNewColorFetching = false;
                self.isInitialized = false;
            });
        },
        changeAltImageSource: function(img){
            var self = this;
            if (img && self.altImage && self.altImage.length > 0) {
                // Set the image URLs with presets
                var query = '?',
                    altImageUnit = self.altImage.find('img, source'),
                    urlFragments = altImageUnit.attr('srcset').split('?');
                if (urlFragments.length === 2) {
                    query += urlFragments[1];
                }

                var altImagePath = SCENE7.SERVER_URL + img + query;
                altImageUnit.attr({
                    'srcset': altImagePath,
                    'src': altImagePath
                });
            }
        }
    };

    $.fn.RolloverAltView = function (options) {
        if (DEBUG && console) console.log('$.fn.RolloverAltView', options);
        return this.each(function () {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if (!instance) {
                instance = new RolloverAltView(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };
} // Close Require.JS wrapper
); // Close Require.JS wrapper
